import styled from 'styled-components'

export const ContainerMessage = styled.div`
  margin-top: 20px;

  @media (max-width: 1200px) {
    padding: 0 50px;
  }
`
